import { render, staticRenderFns } from "./userExchange.vue?vue&type=template&id=3352d8fa&scoped=true"
import script from "./userExchange.vue?vue&type=script&lang=js"
export * from "./userExchange.vue?vue&type=script&lang=js"
import style0 from "./userExchange.vue?vue&type=style&index=0&id=3352d8fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3352d8fa",
  null
  
)

export default component.exports